import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const ProductsContext = createContext({
  product: {},
  shop: {},
});

export function useProductContext() {
  return useContext(ProductsContext);
}

export function useProduct() {
  const { product } = useProductContext();
  return product;
}

export function useShop() {
  const { shop } = useProductContext();
  return shop;
}

export default function ProductProvider({
  children,
  shop,
  product,
}) {
  return (
    <ProductsContext.Provider
      value={{
        product,
        shop,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
}

ProductProvider.propTypes = {
  children: PropTypes.node.isRequired,
  shop: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
};
